"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemGroup = require("@/api/systemGroup");
var _systemConfig = require("@/api/systemConfig");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      active: 0,
      tabList: [{
        tit: '热情红',
        class: 'bg1'
      }, {
        tit: '家居橙',
        class: 'bg2'
      }, {
        tit: '生鲜绿',
        class: 'bg3'
      }, {
        tit: '海鲜蓝',
        class: 'bg4'
      }, {
        tit: '女神粉',
        class: 'bg5'
      }],
      themeData: [],
      imgList: [require('@/assets/theme/theme1.png')],
      theme1: [require('@/assets/theme/theme1.png')],
      theme2: [require('@/assets/theme/theme2.png')],
      theme3: [require('@/assets/theme/theme3.png')],
      theme4: [require('@/assets/theme/theme4.png')],
      theme5: [require('@/assets/theme/theme5.png')],
      //主题色
      themeColor: ['#e93323', '#FE5C2D', '#42CA4D', '#1db0fc', '#ff448f']
    };
  },
  mounted: function mounted() {
    this.getSet();
  },
  methods: {
    selected: function selected(index) {
      this.active = index;
      if (index == 0) {
        this.$set(this, 'imgList', this.theme1);
      } else if (index == 1) {
        this.$set(this, 'imgList', this.theme2);
      } else if (index == 2) {
        this.$set(this, 'imgList', this.theme3);
      } else if (index == 3) {
        this.$set(this, 'imgList', this.theme4);
      } else if (index == 4) {
        this.$set(this, 'imgList', this.theme5);
      }
    },
    //获取默认数据
    getSet: function getSet() {
      var _this = this;
      (0, _systemConfig.changeColorApi)().then(function (res) {
        _this.active = res.value - 1;
        _this.imgList = _this.getTheme(res.value);
      });
    },
    // 默认数据种给主题色图片赋值
    getTheme: function getTheme(status) {
      var statusMap = {
        1: this.theme1,
        2: this.theme2,
        3: this.theme3,
        4: this.theme4,
        5: this.theme5
      };
      return statusMap[status];
    },
    // 保存
    saveTheme: (0, _validate.Debounce)(function () {
      var _this2 = this;
      var data = {
        value: this.active + 1
      };
      (0, _systemConfig.saveColorApi)(data).then(function (res) {
        _this2.$message.success('编辑成功');
        _this2.$store.commit('settings/SET_mobileThemeColor', _this2.themeColor[_this2.active]);
      });
    })
  }
};